import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import { Grid, Row, Col, Button, Image } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import IndustrySidebar from '../../components/sidebars/IndustrySidebar';
import * as industryCreators from '../../actions/industries/industryCreators';
import { checkLoggedInUserIsGlobalAdmin } from '../../actions/authentication/authCreators';
import IndustryTabSidebar from './IndustryTabSidebar';
import TieIcon from '../../images/tie-icon.png';
import HelpWrapper from '../../components/HelpWrapper';
import { getSetting } from '../../actions/settings/settingsCreators';

class Industries extends React.Component {
  componentWillMount() {
    this.props.checkLoggedInUserIsGlobalAdmin();
  }

  componentDidMount() {
    const { getSetting } = this.props;
    getSetting('industryHelpPdf');
    getSetting('industryHelpVideo');
  }

  handleSubmit = values => {
    if (values.id) {
      this.props.updateIndustry(values);
    } else {
      this.props.addIndustry(values);
    }
  };

  componentWillReceiveProps(nextProps) {
    this.handleIndustryIdUpdate(nextProps);
  }

  handleIndustryIdUpdate = nextProps => {
    const currentIndustryId = this.props.params.industryId;
    const newCurrentIndustryId = nextProps.params.industryId;

    if (newCurrentIndustryId !== currentIndustryId) {
      this.props.updateCurrentIndustry(parseInt(newCurrentIndustryId, 10));
    }
  };

  render() {
    const { settings } = this.props;
    const currentComponent = this.props.children
      ? this.props.children.type.displayName
      : '';
    return (
      <Grid fluid>
        <Helmet>
          <title>Manage Industries | Campaign Targeter</title>
        </Helmet>
        <Row>
          <Col sm={3} className="sidebar-wrapper">
            <IndustrySidebar {...this.props} />
          </Col>
          <Col sm={9} className="industry-maincontent">
            <div>
              <Row>
                <HelpWrapper
                  pdfUrl={
                    settings && settings.industryHelpPdf
                      ? settings.industryHelpPdf.value
                      : undefined
                  }
                  videoUrl={
                    settings && settings.industryHelpVideo
                      ? settings.industryHelpVideo.value
                      : undefined
                  }
                  extraClass={this.props.children ? 'child-page-present' : ''}
                />
              </Row>
              {!this.props.children && (
                <div>
                  <Link to={`/industries/new`} className="well-300">
                    <Image src={TieIcon} />
                    <Button bsStyle="primary">Create new Industry</Button>
                  </Link>
                </div>
              )}
            </div>
            {this.props.children && (
              <Row className="industries-details">
                <Col sm={4} lg={3} className="industries-sidebar">
                  <IndustryTabSidebar
                    {...this.props}
                    activeTab={currentComponent}
                  />
                </Col>
                <Col sm={8} lg={9} className="industries-maincontent">
                  {React.cloneElement(this.props.children, { ...this.props })}
                </Col>
              </Row>
            )}
          </Col>
        </Row>
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  return {
    industries: state.industries,
    currentOrganisation: state.currentOrganisation,
    currentIndustry: state.currentIndustry,
    settings: state.settings
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...industryCreators,
      checkLoggedInUserIsGlobalAdmin,
      getSetting
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Industries);



// WEBPACK FOOTER //
// ./src/containers/industries/Industries.js